export default {
  path: 'patrol-service/work-orders/inactive',
  name: 'InactiveWorkOrders',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/WorkOrdersIndex')
}
